import BaseApi from "./baseApi";

export default class DeliveryTimeApi extends BaseApi {
    async CreateTicketAutoValid(vin:string, orderType: AssignmentType, debitorNo: string, firstRegistrationDate?: string): Promise<ProductGroup[] | number> {
        const url = `/api/vin/CreateTicketAutoValid/${vin}/${orderType}?debitorNo=${debitorNo}${firstRegistrationDate ? `&firstRegistrationDate=${encodeURIComponent(firstRegistrationDate)}` : ""}`;
        return await this.fetchGet(url);
    }

     async GetTicketUpdate(ticketId:string, orderType: AssignmentType, debitorNo: string, firstRegistrationDate?: string): Promise<{products: ProductGroup[], vin: string} | string> {
        const url = `/api/vin/GetTicketUpdate/${ticketId}/${orderType}?debitorNo=${debitorNo}${firstRegistrationDate ? `&firstRegistrationDate=${encodeURIComponent(firstRegistrationDate)}` : ""}`;
        return await this.fetchGet(url);
    }
}
